import { adventures } from '../../../mocks/adventures';

export default function Adventures() {
  return (
    <section id="adventures" className="py-24 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div className="space-y-8">
            <div>
              <p className="text-sm tracking-widest text-gray-500 uppercase mb-4">東京の奥へ</p>
              <h3 className="text-4xl md:text-5xl font-serif text-gray-900 leading-tight mb-6">
                まだ見ぬ東京に、出会う
              </h3>
              <p className="text-gray-600 leading-relaxed text-base">
                知る人ぞ知る名店、アートの最前線、職人の工房。当ホテルのコンシェルジュが、ガイドブックには載らない東京へとご案内いたします。
              </p>
            </div>
            {adventures.slice(0, 2).map((adventure, index) => (
              <div key={index} className="border-t border-gray-200 pt-6">
                <h4 className="text-xl font-serif text-gray-900 mb-3">{adventure.title}</h4>
                <p className="text-gray-600 text-sm leading-relaxed mb-4">{adventure.description}</p>
                <a href="#" className="text-sm tracking-wide text-gray-900 hover:opacity-70 transition-opacity inline-flex items-center whitespace-nowrap">
                  体験を見る <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            ))}
          </div>
          <div className="grid grid-cols-1 gap-8">
            <div className="w-full h-[500px]">
              <img
                src="/demo/hotel-site/images/adventures-main.png"
                alt="Hotel Experience"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="w-full h-[400px]">
              <img
                src="/demo/hotel-site/images/adventures-pool.png"
                alt="Wellness"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}